module.exports = __webpack_public_path__ + "img/image_7.aed090ed.png";